import globalMixins from '@/mixins/mixins'

export default {
  computed: {
    ...globalMixins.computed
  }
}
